import * as React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { getAllUsers,getUser } from '../../graphql/queries';
import { createOneCredit } from '../../graphql/mutation';
import { useNavigate,useParams } from 'react-router-dom';
import {useState, useEffect} from 'react';
import { Box, Button, TextField, Typography,Snackbar,Alert } from '@mui/material';   

export default function CreateCredit() {
  const navigate = useNavigate();
  const { id: userId } = useParams();
  const [credit, setCredit] = React.useState({
    expiryDate: new Date().toISOString().slice(0, 16),
    userId: userId || '',
    amount: 0,
  });

  const [snackBarOpen,setSnackBarOpen] = useState(false)
  const [snackBarMessage,setSnackBarMessge] = useState(null)
  const [snackBarSeverity, setSnackBarSeverity] = useState('success')
  const [progress, setProgress] = React.useState(false);

const { data: userData } = useQuery(getUser, {
  variables: { userId },
});

useEffect(() => {
  if (userData?.getUser) {
    setCredit((prev) => ({
      ...prev,
      userId
    }));
  }
}, [userData]);

const handleChange = (e) => {
  const { name, value, type } = e.target;

  setCredit((prev) => ({
    ...prev,
    [name]: type === 'number' ? parseInt(value, 10) : value,
  }));
};

    const handleSnackBarClose=()=>{
  setSnackBarOpen(false)
}

  const [createOneCreditMutation] = useMutation(createOneCredit);

    const handleCreateCredit = async () => {
      if (!credit.expiryDate || !credit.amount) {
        setSnackBarMessge('Please fill in all fields');
        setSnackBarSeverity('error');
        setSnackBarOpen(true);
        return;
      }

      setProgress(true);
      try {
        const response = await createOneCreditMutation({
          variables: {
            userId: credit.userId,
            amount:credit.amount,
            expiryDate: new Date(credit.expiryDate).toISOString()
          },
        });

        if (response.data) {
          setSnackBarMessge('Credit created successfully');
          setSnackBarSeverity('success');
          setSnackBarOpen(true);
          setTimeout(() => {
            window.location.href = `/users/${credit.userId}`;
        }, 1000);
          
        } else {
          setSnackBarMessge('Credit create failed');
          setSnackBarSeverity('error');
          setSnackBarOpen(true);
        }
      }  catch (error) {
        const message =
        error?.graphQLErrors?.[0]?.message || 'An unexpected error occurred';
        setSnackBarMessge(message);
        setSnackBarSeverity('error');
        setSnackBarOpen(true);
      }
 finally {
        setProgress(false);
      }
    };

  return (
    <Box sx={{ maxWidth: 1000, mx: 'auto', p: 4 }}>

      <Snackbar
      open={snackBarOpen}
      autoHideDuration={3000}
      onClose={handleSnackBarClose}
      message={snackBarMessage}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
          <Alert 
          onClose={handleSnackBarClose} 
          severity={snackBarSeverity} 
          sx={{ width: '100%' }}
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>

      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Credit Credit
        </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 900, mx: 'auto', p: 4 }}>
        <Box sx={{ p: 3, borderRadius: 3, backgroundColor: '#f7f7f9', width: '80%' }}>

            <TextField sx={{p:2 ,mb: 2}}
            label='User ID' 
            value={credit?.userId || '-'}
            key={`readonly-userId`}
            readOnly
            variant="outlined"
            >
            </TextField>

          <TextField sx={{p:2 ,mb: 2}}
            label="Amount"
            name="amount"
            type="number"
            inputProps={{ min: 1, step: 1 }}
            value={credit.amount}
            onChange={handleChange}
            variant="standard"
            fullWidth
          />

          <TextField
          label="Expiry Date"
          name="expiryDate"
          type="datetime-local"
          value={credit.expiryDate}
          onChange={handleChange}
          variant="outlined"
          fullWidth
          InputLabelProps={{ shrink: true }} 
        />

        </Box>

        <Button variant="contained" color="primary" onClick={handleCreateCredit} disabled={progress} sx={{ width: '200px',  }}>
          Create Credit
        </Button>
      </Box>
    </Box>
  );
}
